export class RenewalModuleDashboardlist{

    id:boolean;
    spid:string;
    cust_Id:number
    csd:string;
    ced:string;
    quoteID:number;
    isRenewalProcss:number;
}


export class VisiblitiyGroupParams {
    search: string ;
    pageNo: number = 1;
    pageSize: number = 5;
    pageLength: number = 10;
    user_id:number;
}

export class ClsEncrDec{
    plainText:string
}